// pages/VerifyOTP.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OTPInput from '../components/OTPInput';
import LogoHeader from '../components/LogoHeader';
import { API_ENDPOINTS } from '../config/constants';
import axios from 'axios';

const VerifyOTP = ({ phoneNumber,OTP }) => {
    const [otp, setOtp] = useState(OTP.split(''));
    const [timer, setTimer] = useState(40);
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleVerify = async() => {
        if (otp.every((d) => d)) {
            try{
                const otpString = otp.join('');
                console.log(`Verifying OTP: ${otpString} for phone number: ${phoneNumber}`);
                const response = await axios.post(API_ENDPOINTS.VERIFY_OTP, {
                    phone_number: phoneNumber,
                    otp: otpString
                });
                console.log('OTP verification response:', response);
                console.log(response.data.access_token);
                localStorage.setItem('token',response.data.access_token);
                navigate('/mobile/home');
            } catch (error) {
                console.error('Error verifying OTP:', error);
                alert('Failed to verify OTP. Please try again.');
            }
        }
    };

    return (
        <>
            <LogoHeader />
            <Box className="card">
                <h2 style={{ color: '#110d31' }}>Verify your Phone no.</h2>
                <p style={{ color: '#999' }}>Please enter a 6 digit code sent to your number.</p>
                <p style={{ fontWeight: 600, marginBottom: '1rem' }}>{phoneNumber}</p>
                <OTPInput value={otp} setValue={setOtp} />
                {/* <Box mt={2} mb={2}>
                    <p style={{ color: '#666' }}>{`00:${timer.toString().padStart(2, '0')}`}</p>
                </Box>
                <p style={{ color: '#999' }}>
                    Didn't receive the code?{' '}
                    <Button variant="text" sx={{ color: '#110d31' }}>
                        Resend
                    </Button>
                </p> */}
                <Button
                    variant="contained"
                    endIcon={<CheckCircleIcon />}
                    onClick={handleVerify}
                    sx={{ mt: 2, background: '#110d31' }}
                    fullWidth
                >
                    Verify
                </Button>
            </Box>
        </>
    );
};

export default VerifyOTP;
